const setAmount = (amount) => {
  return {
    type: "SET_AMOUNT",
    payload: amount,
  };
};
export default setAmount;
